/**
 * Base URL for large, regenerable media assets (audio segments, and later
 * models/sprites) that live in the Cloudflare R2 bucket `esoteria-assets`
 * instead of git / the Pages deploy.
 *
 * - In production we set VITE_ASSET_BASE to the bucket's public URL at build
 *   time (see .env.production), so `assetUrl('audio/music/seg_0003.opus')`
 *   resolves to `https://pub-....r2.dev/audio/music/seg_0003.opus`.
 * - In dev (or when the var is unset) it falls back to '' so paths resolve
 *   against Vite's own `public/` dir — no bucket needed for local work.
 *
 * The trailing slash is normalised so callers pass a plain relative key.
 */
const RAW_BASE = (import.meta.env?.VITE_ASSET_BASE ?? '').trim()
const ASSET_BASE = RAW_BASE.replace(/\/+$/, '')

/** Resolve a public-relative asset key to a full URL (R2 in prod, /public in dev). */
export function assetUrl(key: string): string {
  const clean = key.replace(/^\/+/, '')
  return ASSET_BASE ? `${ASSET_BASE}/${clean}` : clean
}
